import React from "react";
import { useEffect } from "react";
import Footer from "../components/footer";
import NavbarHome from "../components/navbar-home";
import EventContent from "../pages/Sheets/event-content";
import EventJumbotron from "../pages/Sheets/event-jumbotron";

export default function PageEvent() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <NavbarHome />
      <EventJumbotron />
      <EventContent />
      <Footer />
    </>
  );
}
